import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Link from 'react-router-dom/Link'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import Avatar from 'srcReact/components/common2/Avatar'
import Button from 'srcReact/components/common2/Button'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import RichTextEditor from 'srcReact/components/common2/RichTextEditor'
import Icon from 'srcReact/components/icons/Icon'
import ImagePicker from 'srcReact/MessengerPage/components/ImagePicker'
import AnimatedButton from '../../../AnimatedButton'
import styles from './styles.module.scss'
import AnchorLink from 'srcReact/components/common2/AnchorLink'

function CreateFeedDesktop({
  isEditMode,
  content,
  existingContent, // applicable in case of  draft or edit mode.
  loadingSendMessage,
  loggedInUser,
  closeModal,
  posted,
  filesToUpload,
  handleFiles,
  uploadImageCallBack,
  getFileError,
  messageType,
  commentToUser,
  entity,
  post,
  error,
  fileCount,
  activeUsers,
  isGeneral = false,
  handleShowNewsFeedPopup,
  newsFeedId,
  originMessageId,
  draftMessages,
  handleSendMessage,
  handleChange,
  handleFocus,
  handleBlur,
  focusedMode,
  handleErrorFromInputArea,
  cancelPost,
  showGroupInfoBanner
}) {
  const { t } = useTranslation()
  const rteRef = useRef(null)
  return (
    <React.Fragment>
      <div className={styles.image}></div>

      <div className={styles.container}>
        <button type='button' className={styles.closeButton} onClick={closeModal}>
          <Icon name='close24' />
        </button>
        <header className={styles.header}>
          {isGeneral && !isEditMode && !showGroupInfoBanner && (
            <button className={styles.selectedNewsFeed} onClick={handleShowNewsFeedPopup}>
              {entity.picture?.length > 0 || entity.picture?.url?.length > 0 ? (
                <img
                  src={entity.picture.url ? entity.picture.url : entity.picture}
                  alt={entity.name}
                  className={styles.picture}
                />
              ) : (
                <img
                  src={require('../../../../../assets/images/background-default-mixr.jpg')}
                  alt='default'
                  className={styles.picture}
                />
              )}
              <span className={styles.title}>{entity.name}</span>
              {isGeneral && <Icon name='chevron-down' className={styles.chevronDownIcon} />}
            </button>
          )}
          {showGroupInfoBanner && messageType !== 'comment' && !isGeneral && (
            <AnchorLink isNative={false} path={`/0/home/${entity.type}/${entity.id}`} className={styles.mainEntityName}>
              {entity.picture?.length > 0 || entity.picture?.url?.length > 0 ? (
                <img src={entity.picture.url} alt={entity.name} className={styles.picture} />
              ) : (
                <img
                  src={require('../../../../../assets/images/background-default-mixr.jpg')}
                  alt='default'
                  className={styles.picture}
                />
              )}
              <span className={styles.title}>{entity.name}</span>
            </AnchorLink>
          )}
          <h1
            className={`${styles.title} ${
              ((isGeneral && !isEditMode) || showGroupInfoBanner) && styles.newsFeedTitle
            }`}>
            {messageType === 'comment'
              ? t('mixrHome.feeds.commentPlaceholder')
              : messageType === 'reply'
              ? t('mixrHome.feeds.replyPlaceholder')
              : isEditMode
              ? t('createPost.titleEdit')
              : t('createPost.title')}
          </h1>
          <Avatar
            imgWrapperSize='medium'
            userId={loggedInUser.id}
            profilePicture={loggedInUser.profile_picture}
            containerCSS={styles.avatar}
            mimeType={loggedInUser.mime_type}
            originalTag={loggedInUser.original_tag}
            isOriginal={loggedInUser.is_original}
            withExpertiseGroup={loggedInUser.with_expertise_group}
          />
        </header>

        {(messageType === 'comment' || messageType === 'reply') && (
          <React.Fragment>
            <div className={styles.entity}>
              <h2 className={styles.entityName}>
                {t('createPost.commentTitle1')}&nbsp;
                <Link to={`/0/profile/${commentToUser.id}`}>
                  {/* {t('createPost.ones', { name: `${commentToUser.firstname} ${commentToUser.lastname}` })} */}
                  {commentToUser.firstname}
                  {commentToUser.lastname}
                </Link>
                's {t('createPost.commentTitle2')} <span className={styles.greenMixrText}>{entity.name}</span>
              </h2>
            </div>
            <div className={styles.postContainer}>
              <Avatar
                userId={commentToUser.id}
                profilePicture={commentToUser.profile_picture_url}
                showUserName={false}
                imgWrapperSize='tiny'
                mimeType={commentToUser.mimeType}
                originalTag={commentToUser.originalTag}
                isOriginal={commentToUser.isOriginal}
                withExpertiseGroup={commentToUser.with_expertise_group}
              />
              <div
                className={styles.originalPostMessage}
                dangerouslySetInnerHTML={{
                  __html:
                    post.message.length > appConstantSettings.COMMENT_POPUP_TEXT_MAX_LENGTH
                      ? `${post.message.slice(0, appConstantSettings.COMMENT_POPUP_TEXT_MAX_LENGTH)}...`
                      : post.message
                }}
              />
            </div>
          </React.Fragment>
        )}

        <div
          ref={rteRef}
          data-typeid={entity && entity.id}
          data-type={entity && entity.type}
          data-groupid={entity && entity.groupId}
          className={`${appConstantSettings.DIV_TAG_CONTAINER}_CREATE_POST ${styles.editorContainer} ${
            focusedMode ? (content.hasError ? styles.editorContainerErrorFocused : styles.editorContainerFocused) : ''
          }`}
          onFocus={handleFocus}
          onBlur={handleBlur}>
          <RichTextEditor
            isEditMode={isEditMode}
            showTextFormatter={true}
            showEmojiPicker={true}
            showDocumentPicker={!isEditMode}
            showFilePicker={!isEditMode}
            showToolbar={true}
            placeholder={
              messageType === 'comment'
                ? t('mixrHome.feeds.commentPlaceholder')
                : messageType === 'reply'
                ? t('mixrHome.feeds.replyPlaceholder')
                : `${t('global.writePost')}...`
            }
            handleChange={handleChange}
            getFileError={getFileError}
            containerCSS={styles.richTextAreaWrapper}
            charLimit={appConstantSettings.MAX_CHAR_COUNT}
            maxLines={appConstantSettings.MAX_LINES}
            handleInputError={handleErrorFromInputArea}
            editorId={`createPost`}
            errorMessageRequired={t('error.required', { field: t(`formlabel.${content.name}`) })}
            errorMessageLimitExceed={t('global.messageLimit', {
              limit: appConstantSettings.MAX_CHAR_COUNT
            })}
            keepFormatOnPopulate={true}
            showAdvFormat={true}
            existingFiles={filesToUpload}
            handleFiles={handleFiles}
            activeUsers={activeUsers}
            mentionMenuOrientation='bottom'
            value={existingContent}
            focusInput={true} //directly focus RTE(with cursor), once popup is open
          />
        </div>
        {content && content.hasError && <ErrorMessage text={content.errorMessage} className={styles.error} />}
        {error && error.length > 0 && <ErrorMessage text={error} className={styles.error} />}
        {filesToUpload?.length > 0 && (
          <div className={styles.actionsContainer}>
            <ImagePicker
              uploadFileCallback={uploadImageCallBack}
              allowedImageTypes={appConstantSettings.ACCEPTED_IMAGE_TYPES}
              allowedImageSizeInMB={appConstantSettings.MAX_IMAGE_SIZE_MB}
              filesLimit={appConstantSettings.FILES_LIMIT}
              getFileError={getFileError}
              allowDocs={false}
              allowImages={true}
              iconText={t('createPost.picture')}
            />
            <ImagePicker
              uploadFileCallback={uploadImageCallBack}
              allowedDocumentTypes={appConstantSettings.ACCEPTED_DOCUMENT_TYPES}
              allowedDocumentSizeInMB={appConstantSettings.MAX_DOC_SIZE_MB}
              filesLimit={appConstantSettings.FILES_LIMIT}
              getFileError={getFileError}
              allowDocs={true}
              allowImages={false}
              iconText={t('global.document')}
            />
          </div>
        )}
        <div className={styles.buttonWrapper}>
          <Button text={t('global.cancel')} type='button' style='tertiary' size='large' handleClick={cancelPost} />
          <AnimatedButton
            loading={loadingSendMessage} //show loading only for plain text message feed
            isDone={posted} //if message contains only text or message has atleast one file, close the modal by marking it as done
            afterText={isEditMode ? t('createPost.btnUpdated') : t('createPost.btnPosted')}
            beforeText={isEditMode ? t('global.update') : t('global.post')}
            onClick={handleSendMessage}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default CreateFeedDesktop
